// El cliente de Supabase, cargado con import() (LDT-718).
//
// La landing solo lo usa al enviar un formulario, al comprobar un correo en el
// checkout y para el contador de usuarios de la portada. Importado arriba del
// todo, viajaba en el trozo de entrada (~100 KB comprimidos con auth, realtime
// y storage) y se descargaba antes de pintar. Es el mismo cliente
// (`@/integrations/supabase/client`), con la misma sesión.
export function loadSupabase() {
  return import("@/integrations/supabase/client").then((m) => m.supabase);
}
